import axios from 'axios';
import api from '../../../utils/api';

export default {
  async getImages(_, payload) {
    const { data } = await axios(api.mediaArchive.fetchImages(payload));
    return data;
  },
  async getVideos(_, payload) {
    const { data } = await axios(api.mediaArchive.fetchVideos(payload));
    return data;
  },
  async getPostGuides(_, payload) {
    const { data } = await axios(api.mediaArchive.fetchPostGuide(payload));
    return data;
  },
  async shareImageAsPost(_, mediaData) {
    await axios(api.mediaArchive.shareImageAsPost(mediaData));
  },
  async likeEventMedia(_, likeData) {
    const { data } = await axios(api.mediaArchive.likeEventMedia(likeData));
    return data;
  },
  async dislikeEventMedia(_, id) {
    await axios(api.mediaArchive.dislikeEventMedia(id));
  },
  async likeAwardMedia(_, likeData) {
    const { data } = await axios(api.mediaArchive.likeAwardMedia(likeData));
    return data;
  },
  async dislikeAwardMedia(_, id) {
    await axios(api.mediaArchive.dislikeAwardMedia(id));
  },
  async getBase64Img(_, details) {
    const { data } = await axios(api.mediaArchive.getBase64Img(details));
    return data;
  },
};
